import { render, staticRenderFns } from "./KwtSubmitButton.vue?vue&type=template&id=6f4215f0&scoped=true&"
import script from "./KwtSubmitButton.vue?vue&type=script&lang=js&"
export * from "./KwtSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./KwtSubmitButton.vue?vue&type=style&index=0&id=6f4215f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4215f0",
  null
  
)

export default component.exports